var _a, _b, _c, _d, _e, _f;
import { PeerTypeEnum } from '@workalizer/shared';
import { diffComparisonType, diffComparisonValueFormat } from '@workalizer/shared/types';
import { calculateAverage, getInterval, getPercentageDiff, groupByPeriod } from '@workalizer/shared/utils';
import { endOfDay, startOfDay } from 'date-fns';
var buildDurationDiff = function (previous, current) {
    return getPercentageDiff(previous, current, {
        comparisonValueFormat: diffComparisonValueFormat.durationSeconds
    });
};
var buildTeamAvgDiff = function (teamTotal, current) {
    return getPercentageDiff(calculateAverage(teamTotal, 4), current, {
        comparisonType: diffComparisonType.teamAverage,
        comparisonValueFormat: diffComparisonValueFormat.durationSeconds
    });
};
var buildTotalsBlock = function (meetings, chats, gmails, prevMeetings, prevChats, prevGmails, teamMeetings, teamChats, teamGmails) { return ({
    meetings: meetings,
    chats: chats,
    gmails: gmails,
    prevMeetings: prevMeetings,
    prevChats: prevChats,
    prevGmails: prevGmails,
    diffMeetings: buildDurationDiff(prevMeetings, meetings),
    diffChats: buildDurationDiff(prevChats, chats),
    diffGmails: buildDurationDiff(prevGmails, gmails),
    teamAvgMeetings: buildTeamAvgDiff(teamMeetings, meetings),
    teamAvgChats: buildTeamAvgDiff(teamChats, chats),
    teamAvgGmails: buildTeamAvgDiff(teamGmails, gmails)
}); };
var mockPeriodsData = [
    (_a = {},
        _a[PeerTypeEnum.TEAM_INTERNAL] = {
            meetings: 12400,
            chats: 5400,
            gmails: 3100
        },
        _a[PeerTypeEnum.OTHER_TEAMS] = { meetings: 8200, chats: 3200, gmails: 1800 },
        _a[PeerTypeEnum.EXTERNAL] = { meetings: 6100, chats: 2100, gmails: 1500 },
        _a),
    (_b = {},
        _b[PeerTypeEnum.TEAM_INTERNAL] = { meetings: 9800, chats: 4300, gmails: 2500 },
        _b[PeerTypeEnum.OTHER_TEAMS] = { meetings: 7100, chats: 2500, gmails: 1400 },
        _b[PeerTypeEnum.EXTERNAL] = { meetings: 5200, chats: 1500, gmails: 1200 },
        _b),
    (_c = {},
        _c[PeerTypeEnum.TEAM_INTERNAL] = {
            meetings: 15300,
            chats: 6700,
            gmails: 3900
        },
        _c[PeerTypeEnum.OTHER_TEAMS] = { meetings: 10400, chats: 4100, gmails: 2300 },
        _c[PeerTypeEnum.EXTERNAL] = { meetings: 8300, chats: 3300, gmails: 1900 },
        _c),
    (_d = {},
        _d[PeerTypeEnum.TEAM_INTERNAL] = {
            meetings: 11200,
            chats: 5100,
            gmails: 2800
        },
        _d[PeerTypeEnum.OTHER_TEAMS] = { meetings: 8700, chats: 3500, gmails: 2000 },
        _d[PeerTypeEnum.EXTERNAL] = { meetings: 6700, chats: 2500, gmails: 1600 },
        _d),
    (_e = {},
        _e[PeerTypeEnum.TEAM_INTERNAL] = {
            meetings: 13400,
            chats: 5900,
            gmails: 3400
        },
        _e[PeerTypeEnum.OTHER_TEAMS] = { meetings: 9500, chats: 4700, gmails: 2200 },
        _e[PeerTypeEnum.EXTERNAL] = { meetings: 7700, chats: 3700, gmails: 2100 },
        _e)
];
var mockTotals = (_f = {},
    _f[PeerTypeEnum.TEAM_INTERNAL] = buildTotalsBlock(62100, 27400, 15700, 59800, 26300, 14900, 68000, 29000, 16200),
    _f[PeerTypeEnum.OTHER_TEAMS] = buildTotalsBlock(43900, 18000, 9700, 42000, 17000, 9100, 47000, 19500, 10200),
    _f[PeerTypeEnum.EXTERNAL] = buildTotalsBlock(34000, 13100, 8300, 32000, 12000, 7600, 36000, 14000, 8800),
    _f);
export var communicationByCollaborativeTime = function (input) {
    var interval = getInterval(input.dateFrom, input.dateTo);
    var periods = groupByPeriod([], startOfDay(input.dateFrom), endOfDay(input.dateTo), interval);
    var periodsData = periods.map(function (period, idx) {
        var _a;
        return (_a = {
                period: period.date
            },
            _a[PeerTypeEnum.TEAM_INTERNAL] = mockPeriodsData[idx % mockPeriodsData.length][PeerTypeEnum.TEAM_INTERNAL],
            _a[PeerTypeEnum.OTHER_TEAMS] = mockPeriodsData[idx % mockPeriodsData.length][PeerTypeEnum.OTHER_TEAMS],
            _a[PeerTypeEnum.EXTERNAL] = mockPeriodsData[idx % mockPeriodsData.length][PeerTypeEnum.EXTERNAL],
            _a);
    });
    return {
        totals: mockTotals,
        periods: periodsData
    };
};
